export default __webpack_public_path__ + "static/media/MP5_8.f0b0cecf.png";